import React, { Component } from 'react';
import { Tabs } from 'antd';

import CategorySettingsTab from './Tabs/CategorySettings';
import CarouselTab from './Tabs/Carousel/Carousel';
import SponsorTab from './Tabs/Sponsor/Sponsor';
import HomeStat from './Tabs/HomeStat';
import HomeBlock from './Tabs/HomeBlock';

// const ContactTab = () => (
//   <div>Contact</div>
// );

// const UDTab = () => (
//   <div>Utility Documents</div>
// );

class HomePage extends Component {
  render() {
    const { formItemLayout } = this.props;

    return (
      <Tabs defaultActiveKey="1">
        <Tabs.TabPane tab="Vị trí danh mục" key="1">
          <CategorySettingsTab formItemLayout={formItemLayout} />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Thiết đặt slider" key="2">
          <CarouselTab />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Số thống kê" key="4">
          <HomeStat />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Block ảnh" key="5">
          <HomeBlock />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Đơn vị liên kết" key="3">
          <SponsorTab />
        </Tabs.TabPane>
        {/* <Tabs.TabPane tab="Liên hệ" key="3">
          <ContactTab />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Văn bản tiện ích" key="4">
          <UDTab />
        </Tabs.TabPane> */}
      </Tabs>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/screens/Dashboard/Categories/Governance/HomePage/HomePage.js